import { useMemo } from "react";
import { useAppSelector } from "../../framework/redux/hooks";
import { GenericNotificationDto, isWorkShiftNotification } from "../../models/notification/notification";

export const useSelectWorkShiftNotifications = (): GenericNotificationDto[] => {
    const all = useAppSelector((s): any[] => s.notification.notifications);
    return useMemo(
        () => all.filter((n: any) => isWorkShiftNotification(n) && !n.confirmedDateTime) as GenericNotificationDto[],
        [all]
    );
};